import { mapShopPipeline } from 'app/pages/tpoPortal/commandCenterHome/CommandCenterHome/shopPipeline.utils';
import { brokerPipelineApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { CommandCenterLoadKey, markCommandCenterLoadedAction } from './loadStatus.actions';

// Broker-facing read — a 403 (DEV-3647 broker-auth gap) must degrade to the empty
// state, never trigger the global forbidden page-reload loop.
const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_SHOP_PIPELINE_ACTION_TYPE = createNamedActions(
  'commandCenterShopPipeline',
  {
    SET_SHOP_PIPELINE: 'SET_SHOP_PIPELINE',
  },
);

export const getShopPipelineAction = catchAsyncActionError(() => async dispatch => {
  try {
    const { data } = await brokerPipelineApi.getBrokerPipelineLoans({
      config: SKIP_FORBIDDEN_CONFIG,
    });

    return dispatch({
      type: COMMAND_CENTER_SHOP_PIPELINE_ACTION_TYPE.SET_SHOP_PIPELINE,
      payload: mapShopPipeline(data ?? null),
    });
  } finally {
    dispatch(markCommandCenterLoadedAction(CommandCenterLoadKey.SHOP_PIPELINE));
  }
});
